<app-sidebar />

<main>
    @if (!headerHidden()) {
        <app-header>
            <app-breadcrumb />
        </app-header>
    }

    <router-outlet />
</main>

<app-footer />

<app-upload-tray />

<router-outlet name="admin" />
<router-outlet name="modal" />
